import React from "react";
import PropTypes from "prop-types";
import "./modal.css";
import { Button, Modal } from "react-bootstrap";
import parse from 'html-react-parser';

//Base de modal generico
function ItemModal({show, title, content, confirm, cancel,error="",id='itemModal'}){

    //Evita que a página atualize no form
    const handleSubmit = (event) => {
        event.preventDefault();
        confirm?.func();
    }
    const handleKeyPress = (event) => {
        if (event.key === 'Enter') {
          confirm?.func();
        }
    }
    return(
        <Modal  id={id} className="itemModal" show={show} onHide={cancel.func}>
          <Modal.Header closeButton>
            <Modal.Title>{title}</Modal.Title>
          </Modal.Header>
          <form  onSubmit={handleSubmit} onKeyPress={handleKeyPress} >
              <Modal.Body>
                <div className="d-grid">{content}</div>
                <p className="error">{parse(error)}</p>
              </Modal.Body>
              <Modal.Footer>
                {cancel &&
                    <Button variant="secondary" type="submit" onClick={cancel.func}>
                      {cancel?.name}
                    </Button>}
                {confirm &&
                    <Button variant="primary" type="submit" >
                      {confirm?.name}
                    </Button>}
              </Modal.Footer>
          </form>
        </Modal>)
}
Modal.propTypes = {
  show: PropTypes.bool, // Se vai estar visivel ou não
  id: PropTypes.string, //Id do item
  title:PropTypes.string, //Titulo do Modal
  content:PropTypes.object, // Conteúdo do Modal ex: inputs, selects, textos...
  confirm:PropTypes.shape({ //dados do botão de confirmação
      name: PropTypes.string, // texto do botão
      func: PropTypes.array // função que vai ser chamada ao clicar no botão
    }),
  cancel:PropTypes.shape({ //dados do botão de cancelamento e no X
      name: PropTypes.string, // texto do botão
      func: PropTypes.array // função que vai ser chamada ao clicar no botão
    }),
  error:PropTypes.string //Mensagem de erro que pode ser convertido em HTML
};
export default ItemModal;